
function Nav() {
  return <h2>Expense Tracker</h2>;
}

export default Nav;
